import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchAlt2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 49,
	height: 48,
	viewBox: "0 0 49 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.5 12C28.0228 12 32.5 16.4772 32.5 22M33.8176 33.3098L42.5 42M38.5 22C38.5 30.8366 31.3366 38 22.5 38C13.6634 38 6.5 30.8366 6.5 22C6.5 13.1634 13.6634 6 22.5 6C31.3366 6 38.5 13.1634 38.5 22Z",
		stroke: "currentColor",
		strokeWidth: 4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSearchAlt2;
